import { client } from "api";

export type UnassignOrderSerialRequest = { serialId: string };
export type UnassignOrderSerialResponse = string;

export const unassignOrderSerial = ({ serialId }: UnassignOrderSerialRequest) =>
  client
    .delete<UnassignOrderSerialResponse>(`/checklist/serial/${serialId}`)
    .then((res) => res.data);
